import React from "react";

interface CircleOutlineIconProps
  extends Omit<React.SVGProps<SVGSVGElement>, "width" | "height" | "fill"> {
  width?: number | string;
  height?: number | string;
  fill?: string;
}

const CircleOutlineIcon: React.FC<CircleOutlineIconProps> = ({
  width = 16,
  height = 16,
  fill = "none",
  ...props
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <circle cx="8" cy="8" r="7.5" stroke="#1A1A1A" />
      <circle cx="8" cy="8" r="7.5" stroke="black" strokeOpacity="0.2" />
      <circle cx="8" cy="8" r="7.5" stroke="black" strokeOpacity="0.2" />
      <circle cx="8" cy="8" r="7.5" stroke="black" strokeOpacity="0.2" />
    </g>
    <defs>
      <clipPath id="clip0_1915_7724">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default CircleOutlineIcon;
